import { useAutoApplyQueueTutorialStore } from '../store/autoapply-queue-tutorial.store.js';
import { useOnboardingRetentionStore } from '../store/onboarding-retention.store.js';

// EN-1251: the AutoApply tab is part of the Job Board, and the queue is where the first application is finished, so
// the search and the queue are one first-run page: moves between them pass, and leaving either one is interrupted.
const FIRST_RUN_ROUTE_NAMES = ['job-board-search', 'job-board-autoapply'];

// EN-638: interrupt navigation away from the first-run job board (sidebar items, WAI logo, and
// the JBAI Saved/Job Alerts tabs all route through Vue Router) with the exit-intent modal, until
// the net-new free user has sent an application (EN-1185) or chooses "Leave Anyway" once this session.
// The route check comes first: isExitIntentWindowOpen() is a store action, so calling it on every
// navigation would add a Sentry breadcrumb and state snapshot to each one.
export const exitIntentGuard = (to, from) => {
	const retention = useOnboardingRetentionStore();

	if (
		FIRST_RUN_ROUTE_NAMES.includes(from.name)
		&& !FIRST_RUN_ROUTE_NAMES.includes(to.name)
		&& !retention.exitIntentDismissedThisSession
		// The queue tour (EN-1250) returns to the Job Board page it started from, such as Saved: its own move.
		&& !useAutoApplyQueueTutorialStore().isOriginRoute(to.name)
		&& retention.isExitIntentWindowOpen()
	) {
		retention.requestExitIntent(to.fullPath);
		return false;
	}
};
